import React from "react";


const createColumnsTable = (dataHeaders,statusFields) => {
    let columns = [];
    //Add Headers Titles
    for (let header of dataHeaders) {
        let column = {};
        if ("tooltip" in header){
            column["Header"] =  () => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
        }
        else{
            column["Header"] = header.label;
        }
        column["accessor"] = header.key;
        column["minWidth"] = 120;
        //Add Status Choices
        if (statusFields.includes(header.key)) {
            column["Filter"] = ({ filter, onChange }) =>
            <select
                onChange={event => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : "all"}
            >
                <option value="">all</option>
                <option value="waiting">waiting</option>
                <option value="in_process">in_process</option>
                <option value="fail">fail</option>
                <option value="pass">pass</option>
            </select>;
            column["filterMethod"] = (filter, rows) => matchSorter(rows, filter.value, { keys: ["index"] });
            column["filterAll"] = true;
            column["sortable"] = false;
        }
        else if (["in_platform", "processed"].includes(header.key)) {
            column["Filter"] = ({ filter, onChange }) =>
            <select
                onChange={event => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : "all"}
            >
                <option value="">all</option>
                <option value="false">false</option>
                <option value="true">true</option>
            </select>;
            column["filterMethod"] = (filter, rows) => matchSorter(rows, filter.value, { keys: ["index"] });
            column["filterAll"] = true;                
        }
        else if(header.key === "date"){
            column["filterable"] = false;
        }

        columns.push(column);
    }
    return columns;
}

export default createColumnsTable;